import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { ImagesState } from '../../store/images.state';
import { Observable } from 'rxjs';
import { UploadedItem } from '@app/_models/images-manager/images-management.model';
import { ResetUploadedFiles } from '../../store/images.actions';
import { TranslateService } from '@ngx-translate/core';
import { IMAGE_MANAGER_DIALOG_DATA } from '../../img-modal.component';
import { environment } from '@env/environment.local';
import { SidebarState } from '@app/core/sidebar/store/sidebar.state';
import { AppState } from '@app/core/store/app.state';

@Component({
    selector: 'upload-images',
    templateUrl: 'upload-images.component.html',
    styleUrls: ['upload-images.component.scss'],
})
export class UploadImagesComponent {
    assetsUrl: string = environment.assets_url;
    mfsPath: string = environment.mfs_path;
    cards = [];

    selectedCardId: number | null = 1;

    loading: boolean = false;

    @Select(ImagesState.getUploadedFiles)
    uploadedFiles$: Observable<UploadedItem[]>;

    @Select(AppState.isMobile)
    isMobile$: Observable<boolean>;

    constructor(
        public dialogRef: MatDialogRef<UploadImagesComponent>,
        @Inject(MAT_DIALOG_DATA) public params: IMAGE_MANAGER_DIALOG_DATA,
        private store: Store,
        private translate: TranslateService
    ) {
        this.uploadedFiles$.subscribe((files) => {
            if (files?.length) {
                this.store.dispatch(new ResetUploadedFiles());
                this.dialogRef.close(files);
            }
        });

        const initialInfo = Object.values(this.store.selectSnapshot(SidebarState.initialInfo).data.services);
        const sourcesNames = initialInfo.map((s) => s.name);
        console.log('test', sourcesNames);

        this.cards = [
            {
                title: this.translate.instant('app.global.modals.image_manager.upload_image_modal.options.computer'),
                icon: 'fa-light fa-computer fa-2x fa-fw mr-2',
                show: environment.image_manager.upload_options.pc,
                id: 1,
            },
            {
                title: this.translate.instant('app.global.modals.image_manager.upload_image_modal.options.link'),
                icon: 'fa-light fa-paperclip fa-2x fa-fw mr-2',
                show: environment.image_manager.upload_options.url,
                id: 2,
            },
            {
                title: this.translate.instant('app.global.modals.image_manager.upload_image_modal.options.instagram'),
                icon: 'fa-brands fa-instagram ig-icon fa-2x fa-fw mr-2',
                show: sourcesNames.includes('instagram_gallery'),
                id: 3,
            },
            {
                title: this.translate.instant('app.global.modals.image_manager.upload_image_modal.options.pexels'),
                url: '/img/front/images/pexelsIcon.png',
                show: sourcesNames.includes('image_bank_pexels'),
                id: 4,
            },
        ];
    }

    closeDialog() {
        this.dialogRef.close();
    }

    selectCard(id: number) {
        this.selectedCardId = id;
    }
}
